/**
 * 网站全局配置
 * 集中管理网站的基本信息，便于维护和更新
 */
export interface SiteConfig {
  /** 网站名称 */
  siteName: string
  /** 版权信息 */
  copyright: string
  /** ICP备案号 */
  icpNumber: string
  /** ICP备案查询链接 */
  icpLink?: string
  /** 公安备案号（可选） */
  policeNumber?: string
  /** 公安备案查询链接（可选） */
  policeLink?: string
}

const config: SiteConfig = {
  siteName: '我的工具平台',
  copyright: 'My Tools Platform ©2024 Created with Rust & React',
  icpNumber: import.meta.env.VITE_ICP_NUMBER || '蜀ICP备2025133044号-2',
  icpLink: 'https://beian.miit.gov.cn/',
  // 如需添加公安备案，可取消以下注释并填写相关信息
  // policeNumber: '川公网安备 xxxxxxxxx号',
  // policeLink: 'http://www.beian.gov.cn/portal/registerSystemInfo',
}

export default config
